<template>
    <div class="create-info">
        <mc-form
            ref="form"
            :model="form"
            :rules="rules"
            :label-width="120"
            label-suffix="："
            class="max-width-750 w-full"
        >
            <mc-form-item
                label="供货名称"
                prop="supplierId"
            >
                <mc-select
                    v-model="form.supplierId"
                    :source="supplierList"
                    :clearable="false"
                    :filterable="true"
                    :useScroll="true"
                    class="supplier-select"
                    placeholder="请选择供货规则"
                    :disabled="supplierList.length === 1 || MixinJudgeRejectedAttrsDisabled('supplierId') || !!preSkuId"
                    @change="supplierChanged"
                />
            </mc-form-item>
            <mc-form-item
                label="采购mis号"
                prop="misId"
            >
                <mc-input
                    v-model="form.misId"
                    placeholder="请填写采购mis号"
                    class="w-460"
                    :disabled="!isDraft || MixinJudgeRejectedAttrsDisabled('misId') "
                    @blur="handleMisIdChange"
                />
                <mc-button
                    v-if="canChangeMisId"
                    size="mini"
                    @click="onEditMisId"
                >
                    修改
                </mc-button>
                <span
                    slot="description"
                >
                    只能填写1个mis号，请咨询采购后进行填写
                </span>
            </mc-form-item>
            <mc-form-item
                label="商品名称"
                prop="commodityName"
            >
                <mc-input
                    v-model="form.commodityName"
                    class="w-460"
                    placeholder="请填写商品名称"
                    :maxlength="CommodityNameMaxLength"
                    :disabled="MixinJudgeRejectedAttrsDisabled('commodityName')"
                    @change="handleCommodityNameChange"
                    @blur="handleCommodityNameFinish"
                />
                <word-count
                    :value="form.commodityName"
                    :limit="CommodityNameMaxLength"
                />
                <FocusTag v-if="focusAttrData.commodityName" />
                <commodity-name-descriptions />
                <div
                    v-if="bgCategorySpec && bgCategorySpec.sku"
                    class="el-form-item__description is-bottom"
                >
                    <div v-if="bgCategorySpec.sku.spec">
                        命名规范：{{ bgCategorySpec.sku.spec }}
                    </div>
                    <div
                        v-if="bgCategorySpec.sku.note"
                        style="white-space: pre-line;"
                    >
                        {{ bgCategorySpec.sku.note }}
                    </div>
                    <div
                        v-if="bgCategorySpec.sku.example"
                        style="margin-top:15px"
                    >
                        示例：{{ bgCategorySpec.sku.example }}
                    </div>
                </div>
            </mc-form-item>
            <mc-form-item
                label="营销词"
                prop="marketingWord"
            >
                <mc-input
                    v-model="form.marketingWord"
                    placeholder="请填写营销词"
                    :maxlength="MarketWordMaxLength"
                    :disabled="MixinJudgeRejectedAttrsDisabled('marketingWord')"
                    class="w-460"
                    @blur="handleMarketingWordFinish"
                />
                <word-count
                    :value="form.marketingWord"
                    :limit="MarketWordMaxLength"
                    class="word-count"
                />
                <FocusTag
                    v-if="focusAttrData.marketingWord"
                    style="margin-left:40px"
                />
                <marketing-descriptions
                    :similar-names-with-marketing-word="similarNamesWithMarketingWord"
                />
            </mc-form-item>
            <mc-form-item
                label="SKU 名称"
                prop="skuName"
            >
                <sku-name :sku-name="form.skuName" />
            </mc-form-item>
            <mc-form-item
                label="后台类目"
                prop="bgCategoryId"
                description-position="bottom"
            >
                <category-cascader
                    :key="form.supplierId"
                    v-model="form.bgCategoryId"
                    use-bg-category
                    :categoryType="1"
                    :supplier-id="+form.supplierId"
                    :has-query-similar-cspu-list="hasQuerySimilarCspuList"
                    :disabled="MixinJudgeRejectedAttrsDisabled('bgCategoryId')"
                    placeholder="请选择或输入搜索后台类目"
                    show-desc
                    @change="handleBgCategoryChange"
                    @loaded="onBgCategoryLoaded"
                />
                <div v-if="recommendValueObj.bgCategoryName">
                    <mc-tag
                        theme="green"
                        type="pure"
                    >
                        推荐
                    </mc-tag>
                    {{ recommendValueObj.bgCategoryName }}
                    <mc-button
                        v-if="!MixinJudgeRejectedAttrsDisabled('bgCategoryId')"
                        type="text"
                        size="small"
                        @click="handleUseRecommendValue(['bgCategoryId', 'bgCategoryName'])"
                    >
                        使用推荐
                    </mc-button>
                </div>
                <span
                    slot="description"
                >
                    若不确定请咨询采购
                </span>
            </mc-form-item>
            <div v-show="showDnaAttrs">
                <div class="xx-h2">
                    DNA属性（可以唯一确定一类商品的属性）
                </div>
                <!-- 内部组件使用el-form能力，修改成本高 -->
                <el-form
                    label-width="120px"
                    label-suffix="："
                >
                    <DnaAttrsWrap
                        v-if="form.bgCategoryId"
                        ref="dnaAttrs"
                        :bg-category-id="form.bgCategoryId"
                        :selected-attr-list="form.dnaAttrs"
                        :recommend-value-obj="recommendValueObj"
                        mode="edit"
                        :need-custom-fixed-attr-name-list="['brandId', 'importFlag', 'storageTemperatureLevel']"
                        :default-disabled="MixinJudgeRejectedAttrsDisabled('dnaAttrs')"
                        :default-single-disabled="[attrDisabledMap.QUALIFICATION_CERTIFICATION]"
                        :custom-fixed-attr-props="customFixedAttrProps"
                        :storage-temperature-level-remark="form.storageTemperatureLevelRemark"
                        :focus-attr-data="focusAttrData"
                        :footer-show-tip="[attrDisabledMap.QUALIFICATION_CERTIFICATION]"
                        :attr-tip-config="attrTipConfig"
                        @selectedDnaAttrList="onDnaAttrsSelected"
                        @attrs-loaded="dnaAttrsLoaded"
                        @changeFixedAttrData="onChangeFixedAttrData"
                        @onExpandChange="onExpandChange"
                    />
                </el-form>
            </div>
            <div class="xx-h2">
                销售属性及形态（销售属性会在app显示供用户选择）
            </div>
            <mc-form-item
                label="销售形态"
                prop="packageType"
                descriptionPosition="bottom"
                description="按&quot;份、盒、个、袋、条、只、箱、包、粒&quot;等送货的选择“标品”，按“kg、g”送货的选择“散装”"
            >
                <!-- mc-choice不支持dictCode，暂未替换 -->
                <xx-radio-group
                    v-model="form.packageType"
                    dic-code="special:product:newsell_package_type"
                    :disabled="MixinJudgeRejectedAttrsDisabled('packageType')"
                    @change="onPackageTypeChange"
                />
            </mc-form-item>
            <mc-form-item
                label="基础单位"
                prop="unitId"
            >
                <template>
                    <base-unit-select
                        v-model="form.unitId"
                        :unit-type="form.packageType"
                        :disabled="MixinJudgeRejectedAttrsDisabled('unitId') || !!preSkuId"
                        @change="onUnitChange"
                    />
                    <span class="el-form-item__description">
                        依据商品包装售卖形态选择，注意：加工码，组合装，选择“组”，“套”
                    </span>
                </template>
            </mc-form-item>
            <mc-form-item
                label="销售规格"
                prop="specActual"
                description-position="bottom"
                class="is-required"
            >
                <!-- 散装 -->
                <span v-if="form.packageType === 2">
                    {{ form.specActual || '--' }} C端展示预览： {{ form.specActual || '--' }}
                </span>
                <!-- 标品才有结构化规格 -->
                <standard-spec
                    v-else
                    ref="standardSpecForm"
                    v-model="form.standardSpecList"
                    :base-unit-id="form.unitId"
                    :base-unit-name="form.unitName"
                    :package-type="form.packageType"
                    :init-spec-actual="form.specActual"
                    :disabled="MixinJudgeRejectedAttrsDisabled('standardSpecList') || !!preSkuId"
                    @spec-actual-change="changeSpecActual"
                />
                <FocusTag v-if="focusAttrData.specification" />
                <span class="el-form-item__description">
                    g、kg，书写格式全部为小写，1000g以下使用g，超过1000g（含1000g）使用kg；液体商品使用L、ml，1000ml以下使用ml（小写），超过1000ml，（含1000ml）使用L（大写）。
                    <mc-link
                        type="text"
                        path="https://vss.baobaoaichi.cn/knowledge/detail.html?id=556"
                    >查看规格填写规范</mc-link>
                </span>
            </mc-form-item>
            <!-- 内部组件使用el-form能力，修改成本高 -->
            <el-form
                label-width="120px"
                label-suffix="："
            >
                <!-- 不展示统地采品归属:20304 -->
                <NewExtAttrsWrap
                    ref="extAttrs"
                    :category-id="form.categoryId"
                    :bg-category-id="form.bgCategoryId"
                    :selected-attr-list="form.keyAttributes"
                    :attr-type="2"
                    :recommend-attr-list="recommendValueObj.skuExtAttrList || []"
                    mode="edit"
                    :dna-attrs-ids="MixinGetDnaExtAttrIds()"
                    :default-disabled="MixinJudgeRejectedAttrsDisabled('extAttrSaleSpec')"
                    :default-attrs-id="[{attrId:20019,id:56364}]"
                    :except-ext-attr-id="[20304]"
                    :is-discount-sku="realBarcodeShow"
                    show-value-image
                    :focused-marking-list="focusAttrData.extAttrList || []"
                    @selectedExtAttrList="onExtAttrSelected"
                    @attrs-loaded="attrsLoaded"
                />
            </el-form>
            <mc-form-item
                v-if="MixinJudgeFixedAttrNotInDna('brandId')"
                label="品牌"
                prop="brandId"
            >
                <!-- 使用推荐值时，根据id查询品牌来正确回显label => handleWatch属性设为true，调用相关接口 -->
                <new-brand-select
                    v-model="form.brandId"
                    handle-watch
                    :disabled="MixinJudgeRejectedAttrsDisabled('brandId')"
                    placeholder="请选择或输入搜索品牌，商品若无品牌请选择无"
                    style="width:200px; display: inline-block;"
                    @change="brandChooseChange"
                />
                <FocusTag v-if="focusAttrData.brandId" />
                <div v-if="recommendValueObj.brandName">
                    <mc-tag
                        theme="green"
                        type="pure"
                    >
                        推荐
                    </mc-tag>
                    {{ recommendValueObj.brandName }}
                    <mc-button
                        v-if="!MixinJudgeRejectedAttrsDisabled('brandId')"
                        type="text"
                        size="small"
                        @click="handleUseRecommendValue(['brandId', 'brandName'])"
                    >
                        使用推荐
                    </mc-button>
                </div>
                <span
                    slot="description"
                >
                    未找到对应品牌？
                    <mc-link
                        path="https://tt.sankuai.com/maicaishiyebu/create?cid=569&tid=5297&iid=24821"
                    >
                        前往申请
                    </mc-link>
                    ,若无法操作申请，请联系采购，让采购申请
                </span>
            </mc-form-item>
            <mc-form-item
                label="SPU名称"
                prop="spuName"
            >
                <spu-search-input
                    v-model="form.spuName"
                    class="large-w w-460"
                    :maxlength="30"
                    :disabled="MixinJudgeRejectedAttrsDisabled('spuName')"
                    :supplier-id="+form.supplierId"
                    :brand-id="form.brandId"
                    :bg-category-id="form.bgCategoryId"
                    :category-id="form.categoryId"
                    @select-item="onSelectSpu"
                />
                <word-count
                    :value="form.spuName"
                    :limit="30"
                />
                <div
                    v-if="bgCategorySpec && bgCategorySpec.spu"
                    class="el-form-item__description is-bottom"
                >
                    <div v-if="bgCategorySpec.spu.spec">
                        命名规范：{{ bgCategorySpec.spu.spec }}
                    </div>
                    <div v-if="bgCategorySpec.spu.example">
                        示例：{{ bgCategorySpec.spu.example }}
                    </div>
                </div>
            </mc-form-item>

            <mc-form-item
                label="SKU搜索词"
                prop="searchKeyWord"
                class="search-key-word w-460"
            >
                <div class="operation-area">
                    <SearchTerms
                        v-model="form.searchKeyWord"
                        :mode="createType === 'createProduct' ? 'edit' : 'view'"
                        :disabled="MixinJudgeRejectedAttrsDisabled('searchKeyWord') || isNotNeedSearchKeyWord"
                        :all-limit="100"
                        :single-limit="10"
                        @save="handleSaveSearchTerms"
                    />
                    <mc-choice
                        :value="form.confirmNoNeedSearchWords ? [true] : []"
                        class="ml-10"
                        :single="true"
                        :source="[{value:true,label:'无需搜索词'}]"
                        :show-check-all="false"
                        @change="handleChangeConfirmNoNeedSearchWords"
                    />
                </div>

                <div slot="description">
                    <SearchKeyWordDesc />
                    <AiSearchKeyWord
                        v-if="!isNotNeedSearchKeyWord"
                        ref="aiSearchKeyWordRef"
                        v-model="form.searchKeyWord"
                        :sku-name="form.skuName"
                        :bg-category-id="form.bgCategoryId"
                        :bg-category-list="bgCategoryList"
                        :mode="mode"
                        @save="handleSaveSearchTerms"
                    />
                </div>
            </mc-form-item>
            <mc-form-item
                label="加工状态"
                prop="skuType"
            >
                <mc-select
                    v-model="form.skuType"
                    :source="skuTypeOptions"
                    clearable
                    :disabled="MixinJudgeRejectedAttrsDisabled('skuType') || !!preSkuId"
                    @change="onSkuTypeChange"
                />
                <span
                    slot="description"
                >
                    打包好、贴好标签，送大仓或站点的，选择“成品”；不打包不贴标签，送大仓或站点的，选择“原料“
                </span>
            </mc-form-item>
            <mc-form-item
                label="售卖城市"
                prop="cityIds"
            >
                <CitySalesSelector
                    v-if="allAreaCityList.length"
                    v-model="form.cityIds"
                    :data="allAreaCityList"
                    :disabled-ids="disabledCityIds"
                    :disabled="MixinJudgeRejectedAttrsDisabled('cityId')"
                    :show-select-all="false"
                />
            </mc-form-item>
        </mc-form>
        <edit-mis-dialog
            ref="editMisDialog"
            :applyId="applyId"
            @success="onMisIdUpdate"
        />
        <similar-cspu-modal
            ref="similarCspuModalRef"
            @confirm="handleUseCspuInfo"
        />
    </div>
</template>

<script>
import Rules from '@lsfe/rules';
import { parseQuery } from '@mcfe/tools';
import NewBrandSelect from 'components/NewBrandSelect';
import NewExtAttrsWrap from 'components/NewExtAttrsWrap';
import {
    skuTypeOptions, materialEnum,
} from 'utils/dataMap';
import WordCount from 'components/WordCount';
import DnaAttrsWrap from 'components/DnaAttrsWrap';
import MixinJudgeDnaAttrs from 'components/DnaAttrsWrap/mixin';
import CategoryCascader from 'components/CategoryCascader';
import { reportLx } from '@lsfe/tools';
import { reportMetric } from 'utils/reportMetric';
import SpuSearchInput from './spuSearchInput';
import {
    createInfoToken, shared, updateSharedState,
} from '../shareState';
import { getBaseModel } from '../baseModel';
import { initCreateInfoForm, formRules } from './config';
import MixinJudgeRejectedAttrsDisabled from '../mixins/rejectedDisabled';
import BaseUnitSelect from '../components/BaseUnitSelect';
import StandardSpec from '../components/StandardSpec';
import SearchTerms from '../../SearchTerms';
import SearchKeyWordDesc from '../../SearchKeyWordDesc';
import AiSearchKeyWord from '../../AiSearchKeyWord';
import EditMisDialog from './EditMisDialog';
import SimilarCspuModal from './SimilarCspuModal';
import FocusTag from '../../../../components/FocusTag';
import { searchSimilarityCspuByName } from '../../../api/similarityCspu';
import SkuName from '../components/SKUName/SKUName';
import CommodityNameDescriptions from '../components/SKUName/CommodityNameDescriptions';
import MarketingDescriptions from '../components/SKUName/MarketingDescriptions';
import CitySalesSelector from '../components/CitySalesSelector';
import {
    getSimilarCSPUNameWithMarketingWord,
    useRecommendAttr,
} from '../../../services/editSkuName/index';
import {
    assembleSKUName,
    splitObjectSKUName,
} from '../../../services/editSkuName/utils';
import {
    skuNameRules,
    MarketWordMaxLength,
    CommodityNameMaxLength,
} from '../../../services/editSkuName/validators';
import { CREATE_NEW_PRODUCT_STEP_NAMES, CREATE_NEW_PRODUCT_STEP, attrDisabledMap } from '../config';


// 当前页面可赋值给表单的cspu信息
const cspuFields = ['bgCategoryId', 'skuName', 'commodityName', 'marketingWord', 'brandId', 'specActual'];
const baseModel = getBaseModel();

export default {
    name: createInfoToken,
    components: {
        SpuSearchInput,
        NewBrandSelect,
        NewExtAttrsWrap,
        WordCount,
        CategoryCascader,
        DnaAttrsWrap,
        BaseUnitSelect,
        StandardSpec,
        EditMisDialog,
        SimilarCspuModal,
        FocusTag,
        SkuName,
        CommodityNameDescriptions,
        MarketingDescriptions,
        SearchTerms,
        SearchKeyWordDesc,
        AiSearchKeyWord,
        CitySalesSelector,
    },
    mixins: [MixinJudgeRejectedAttrsDisabled, MixinJudgeDnaAttrs],
    props: {
        applyId: {
            type: String,
            default: '',
        },
        categoryConfig: {
            type: Object,
            default: () => ({}),
        },
        /**
         * 可区分页面来源：
         * - mode有值：申请编辑页
         * - mode无值：新建品页
         */
        mode: {
            type: String,
            default: '',
        },
        // 新增的props
        encryptedVersion: {
            type: String,
            default: '',
        },
        encryptedPreSkuId: {
            type: String,
            default: '',
        },
        encryptedSupplierId: {
            type: String,
            default: '',
        },
        createProductType: {
            type: String,
            default: '新建品',
        },
    },
    data() {
        return {
            selectSpu: {}, // 当模糊搜索得到 spuList 并选中的其中一个
            allSalesCity: {}, // 售卖城市 -- 也作为全局 shared 状态：全量数据通过 基础服务获取，被勾选且不可反勾选从 提报草稿接口中获取
            createType: 'createProduct', // createProduct新建商品 addCity已有sku扩城
            form: initCreateInfoForm(),
            bgCategorySpec: {
                spu: {},
                sku: {},
            }, // 后台品类配置数据-spu名称和sku名称的命名规范和示例
            supplierList: [], // 供货名称
            skuTypeOptions, // 加工状态
            // misIdRequired: 1, // 1是选填，2是必填
            isDraft: true,
            showDnaAttrs: false,
            recommendValueObj: {},
            isFreshFood: false, // 是否是生鲜品
            hasQuerySimilarCspuList: false, // 是否获取过相似cspu
            focusAttrData: {}, // c端展示重点属性
            similarNamesWithMarketingWord: [],
            MarketWordMaxLength,
            CommodityNameMaxLength,
            // dna属性框注释
            attrTipConfig: {
                // 资质信息提醒
                64: {
                    message: '资质认证根据供应商的商品证书自动更新',
                },
            },
            attrDisabledMap,
            // 资质认证默认值-无资质认证
            defaultAttrsIdMap: [{
                attrId: 64,
                id: 40988,
            }],
            bgCategoryList: [],
            allAreaCityList: [],
        };
    },
    computed: {
        cityPreSkuBriefInfoList() {
            const applyInfoSection = baseModel.models?.applyInfoSection || baseModel.data?.applyInfoSection;
            const citySku = applyInfoSection?.cityIds || [];
            if (!citySku.length) {
                return {};
            }
            // 将 citySku 转换为 citySkuManageInfo 格式
            const citySkuManageInfo = citySku.map((item) => ({
                cityId: item,
            }));
            return {
                citySkuManageInfo,
            };
        },
        // pd 档案中的城市列表（格式：cityId）
        pdArchiveCityList() {
            if (!this.preSkuId) {
                return [];
            }
            const citySkuManageInfo = this.cityPreSkuBriefInfoList?.citySkuManageInfo || [];
            if (!citySkuManageInfo.length) {
                return [];
            }
            // 如果没有 cityPreSkuBriefInfoList，则使用 citySkuManageInfo 中的所有城市（当有 preSkuId 时，这些城市都是 pd 档案带过来的）
            return citySkuManageInfo.map((cityInfo) => cityInfo.cityId);
        },
        // 当前选中的 pd 档案城市列表
        selectedPdArchiveCities() {
            if (!this.preSkuId || !this.pdArchiveCityList.length) {
                return [];
            }
            return (this.form.cityIds || []).filter((cityId) => this.pdArchiveCityList.includes(cityId));
        },
        // 是否只剩下一个 pb 档案的城市
        isOnlyOnePdArchiveCityLeft() {
            return this.preSkuId && this.selectedPdArchiveCities.length === 1;
        },
        // 需要禁用的城市 ID 列表（当只剩下一个 pb 档案城市时，禁用该城市）
        disabledCityIds() {
            if (this.isOnlyOnePdArchiveCityLeft) {
                return this.selectedPdArchiveCities;
            }
            return [];
        },
        rules() {
            const allRules = { ...formRules, ...skuNameRules };
            return allRules;
        },
        // 被驳回后，如果存在白名单 或 黑名单中包含提报信息页面的 禁用字段，则不可以切换
        isRejectedDisabled() {
            const hasCreateInfoKeys = !!(window._.intersection(this.MixinAttrsBlackList, ['cityId', 'fdcGroups', 'skuType', 'applyReason']).length);
            return this.MixinHasWhiteList || hasCreateInfoKeys;
        },
        customFixedAttrProps() {
            return {
                brandId: {
                    disabled: this.MixinJudgeRejectedAttrsDisabled('brandId'),
                },
                importFlag: {
                    disabled: this.MixinJudgeRejectedAttrsDisabled('importFlag', this.getDnaFixdAttrSelectedValue('importFlag'), true, 'dnaImportFlag'),
                },
                storageTemperatureLevel: {
                    disabled: this.MixinJudgeRejectedAttrsDisabled('storageTemperatureLevel'),
                },
            };
        },
        // 是否可以编辑misid
        canChangeMisId() {
            if (this.categoryConfig.flowSpec && this.categoryConfig.flowSpec.canChangeEditor) return true;
            return false;
        },
        categoryConfigTrigger() {
            const { categoryId, bgCategoryId } = this.form;
            return [categoryId, bgCategoryId];
        },
        realBarcodeShow() {
            const list = this.form.keyAttributes.filter((item) => item.attrId === 20019);
            if (list.length && list[0].selectedValues.find((item) => item.id === 56365)) {
                this.indulgenceAssignment();
                return true;
            }
            return false;
        },
        isNotNeedSearchKeyWord() {
            return this.form.confirmNoNeedSearchWords;
        },
        preSkuId() {
            return parseQuery().encryptedPreSkuId || '';
        },
        canRefreshData() {
            return this.encryptedVersion
                   && this.encryptedPreSkuId
                   && this.encryptedSupplierId;
        },
    },
    watch: {
        // 将管理类目id，保存到share中
        'form.categoryId': function (newVal) {
            if (newVal) {
                updateSharedState('categoryId', newVal);
                this.clearValidate();
            }
        },
        // 供应商变化时更新可选的后台类目售卖城市
        'form.supplierId': function () {
            this.fetchCapableCity();
        },
        'form.bgCategoryId': {
            handler(newVal) {
                if (newVal) {
                    this.getBgCategorySpec(newVal);
                }
                // 切换类目后的逻辑：后台类目变化时更新可选的售卖城市
                this.fetchCapableCity();
            },
            immediate: true,
        },
        'form.confirmNoNeedSearchWords': function (val) {
            // 清除之前搜索词的校验结果
            if (this.$refs.form) this.$refs.form.clearValidate('searchKeyWord');
            if (val) {
                this.form.searchKeyWord = '';
                this.rules.searchKeyWord = [];
            } else {
                this.rules.searchKeyWord = [
                    Rules.isRequired('请填写SKU搜索词'),
                ];
            }
        },
        'form.commodityName': function (newVal) {
            this.form.skuName = assembleSKUName(this.form.marketingWord, newVal);
        },
        'form.marketingWord': function (newVal) {
            this.form.skuName = assembleSKUName(newVal, this.form.commodityName);
        },
        // 监听城市选择变化，确保至少保留一个 pd 档案城市
        'form.cityIds': function (newVal, oldVal) {
            if (!this.preSkuId || !this.pdArchiveCityList.length) {
                return;
            }
            // 使用标志位防止无限循环：如果正在恢复 pd 档案城市，则不再处理
            if (this._isRestoringPdCity) {
                return;
            }
            const selectedPdArchiveCities = (newVal || []).filter((cityId) => this.pdArchiveCityList.includes(cityId));
            // 如果当前选中的 pd 档案城市数量为0，则至少保留一个
            if (selectedPdArchiveCities.length === 0 && this.pdArchiveCityList.length > 0) {
                // 如果之前有选中的 pd 档案城市，恢复最后一个；否则选择第一个 pd 档案城市
                const lastSelectedPdCity = (oldVal || []).find((cityId) => this.pdArchiveCityList.includes(cityId));
                const cityToKeep = lastSelectedPdCity || this.pdArchiveCityList[0];
                // 设置标志位，防止在 $nextTick 中修改 form.cityIds 时再次触发 watch
                this._isRestoringPdCity = true;
                this.$nextTick(() => {
                    this.form.cityIds = [...(newVal || []), cityToKeep].filter((id, index, arr) => arr.indexOf(id) === index);
                    this.$message.warning('至少需要保留一个 pd 档案带过来的城市');
                    // 在下一个 tick 清除标志位，确保后续的正常监听可以继续工作
                    this.$nextTick(() => {
                        this._isRestoringPdCity = false;
                    });
                });
            }
        },
    },
    async created() {
        baseModel.registerVM(this, createInfoToken);

        /**
         * 需要初始化的信息
         *  如果有草稿数据，且之前数据中已选择了 sku，则 初始化 skuList 只包含此 currentSku。
         *  allCityIds；skuCityIds；
         *  newSalesCityList；
         *  applyReason
         *  applyDetail
         * 售卖城市的全集是所有经营城市；被选中不可反选的是 currentSkuInfo 是已提报 sku 的城市，需要区分上次新增的城市，这是两种不同的城市列表。列表中是本次新增提报城市。问题：接口中的 citySku 是什么？
         *
         */
        // this.allCityIds = Object.keys(this.allSalesCity);

        // Note: 需要保证 baseModel 中对各个 VM 初始化的属性的 key 和每个组件 VM 实例中配置的 data 中的属性 key 名称一致。
        const createInfo = baseModel.initCreateInfo;
        this.isDraft = baseModel.data && !this.preSkuId ? baseModel.data.status === -10 : true;

        if (createInfo) {
            const {
                form,
            } = createInfo;
            this.form = initCreateInfoForm(form);
        }
        this.getSupplierList();
        this.queryRecommendValue();
        this.queryCspuInfo();
        this.queryFocusAttr();
    },
    methods: {
        /**
         * 处理禁用字段校验错误并上报埋点
         * @param {Array} forms 表单引用数组
         */
        handleDisabledValidatedFieldsError(forms) {
            const disabledAndValidatedFields = [];

            // 处理普通表单字段
            forms.forEach((ref) => {
                if (this.$refs[ref] && this.$refs[ref].fields && Array.isArray(this.$refs[ref].fields)) {
                    this.$refs[ref].fields.forEach((field) => {
                        // 被禁用的字段，且有校验错误，则收集
                        if (field.validateDisabled && field.validateMessage) {
                            disabledAndValidatedFields.push({
                                message: field.validateMessage,
                            });
                        }
                    });
                }
            });

            // 处理特殊表单引用
            const formRefs = ['dnaAttrs', 'extAttrs'];
            formRefs.forEach((ref) => {
                if (this.$refs[ref]) {
                    const fields = this.$refs[ref];
                    if (fields.defaultDisabled && fields?.errList) {
                        disabledAndValidatedFields.push({
                            message: fields.errList.join(','),
                        });
                    }
                }
            });

            // 如果有禁用字段校验错误，则上报埋点
            if (disabledAndValidatedFields.length) {
                reportMetric('supplier_createNewProduct_disabled_validated_error', 1, {
                    disabledAndValidatedMessages: disabledAndValidatedFields.map((item) => `${item.message}`).join(','),
                    supplierCreateNewProductStepName: CREATE_NEW_PRODUCT_STEP_NAMES[CREATE_NEW_PRODUCT_STEP.CREATE_INFO],
                    createProductType: this.createProductType,
                });
            }
        },
        async handleMisIdChange() {
            // 当存在preSkuId且misId有值时，重新获取信息
            if (this.preSkuId && this.form.misId && this.canRefreshData) {
                await this.refreshDataByMisId();
            }
        },
        async queryPbSkuDetail() {
            const draftData = await this.$hPost('/api/vss/shepherd/VssNewSaleQueryTService/queryPbFlowDetail', {
                encryptedVersion: this.encryptedVersion,
                encryptedPreSkuId: this.encryptedPreSkuId,
                encryptedSupplierId: this.encryptedSupplierId,
                mis: this.form.misId,
            });
            return draftData;
        },
        // 当misId变化时，重新获取数据
        async refreshDataByMisId() {
            if (!this.preSkuId) return;

            // 调用父组件的queryPbSkuDetail方法
            const draft = await this.queryPbSkuDetail();

            // 更新相关数据
            if (this.encryptedPreSkuId && baseModel && baseModel.models) {
                baseModel.models.applyInfoSection = draft.applyInfoSection;
                baseModel.models.skuBaseSection = draft.skuBaseSection;
                baseModel.models.citySkuManageSection = draft.citySkuManageSection;
                baseModel.models.qualificationSection = draft.qualificationSection;
                baseModel.models.preSkuId = draft.preSkuId;
                baseModel.models.applyId = draft.applyId || 0;

                baseModel.setData(draft);
            }
        },
        // 根据url中的cspuId，获取cspu信息
        async queryCspuInfo() {
            const { cspuId } = parseQuery();
            if (!cspuId) return;
            const res = await this.$hPost('/api/vss/shepherd/industry/CspuInfoTService/getCspuInfo', { cspuId }).catch(() => ({}));
            const attrsMap = {
                brandId: 1000000,
                spec: 1000002,
            };
            const cspuInfo = {
                ...res?.cspuInfo || {},
                skuName: res?.cspuInfo?.cspuName,
                brandId: res?.cspuInfo?.attrs?.find((item) => item.id === attrsMap.brandId)?.values?.map((child) => child.id)?.[0] || '',
                specActual: res?.cspuInfo?.attrs?.find((item) => item.id === attrsMap.spec)?.values?.map((child) => child.value)?.[0] || '',
            };
            this.hasQuerySimilarCspuList = true; // 后续不再获取cspu信息
            this.handleUseCspuInfo(cspuInfo);
        },
        // 判断是否是生鲜品
        async isFreshCategory() {
            const { bgCategoryId } = this.form;
            if (!bgCategoryId) return;
            const { isFresh } = await this.$hPost('/api/vss/shepherd/industry/CspuInfoTService/isFreshCategory', {
                bgCategoryId,
            }, { cache: true }).catch(() => ({}));
            this.isFreshFood = isFresh === 1;
        },
        // 获取相似cspu列表
        async querySimilarCspuList() {
            const { skuName, bgCategoryId } = this.form;
            // 商品名称或后台类目不存在，不请求
            if (!skuName || !bgCategoryId) return;
            // 非申请详情页（来源该页面会有mode值）&& 非生鲜品 && 没请求过 -> 发起请求
            if (!this.mode && !this.isFreshFood && !this.hasQuerySimilarCspuList) {
                this.hasQuerySimilarCspuList = true;
                const list = await searchSimilarityCspuByName(skuName);
                if (this.$refs.similarCspuModalRef && list?.length) {
                    this.$refs.similarCspuModalRef.popup(list);
                }
            }
        },
        // 将选中的cspu信息填充到表单中
        handleUseCspuInfo(cspuInfo) {
            // 拆分 skuName
            splitObjectSKUName(cspuInfo);
            // 将cspu信息更新到共享数据池中（一些字段在其他页面的表单中，例如codeList）
            updateSharedState('similarCspuInfo', cspuInfo);
            // 本页面有的表单字段，使用cspu信息中的数据
            cspuFields.forEach((item) => {
                this.form[item] = cspuInfo[item];
            });
        },
        // 获取固定属性、扩展属性的推荐值
        async queryRecommendValue() {
            if (!this.form.commodityName) return; // 商品名称是必填参数
            const params = {
                skuName: this.form.commodityName,
                bgCategoryId: this.form.bgCategoryId,
            };
            useRecommendAttr(params, {
                onLoaded: (res) => {
                    this.recommendValueObj = res.recommendMcSku || {};
                },
                onConfirmShow: () => {
                    reportLx('moduleView', 'b_chaoshi_859v3bu6_mv', { sku_id: this.form?.skuBaseId || '' }, { cid: 'c_chaoshi_nfuxc185' });
                },
                onOk: () => {
                    reportLx('moduleClick', 'b_chaoshi_lwby1744_mc', { sku_id: this.form?.skuBaseId || '' }, { cid: 'c_chaoshi_nfuxc185' });
                    this.handleUseRecommendValue(['bgCategoryId', 'bgCategoryName']);
                },
                onCancel: () => {
                    reportLx('moduleClick', 'b_chaoshi_hiyfrhc5_mc', { sku_id: this.form?.skuBaseId || '' }, { cid: 'c_chaoshi_nfuxc185' });
                },
            });
        },
        // 获取重点属性
        async queryFocusAttr() {
            if (!this.form.bgCategoryId) return;
            const res = await this.$hPost('/api/vss/shepherd/ProductAttrDescQueryTService/queryAttrDescByBgCategoryId', { bgCategoryId: this.form.bgCategoryId }).catch(() => ({}));

            this.focusAttrData = {
                extAttrList: (res.extAttrDesc || []).filter((item) => item.appDisplay).map((item) => item.attrId),
            };
            (res.fixedAttrDesc || []).forEach((item) => {
                this.focusAttrData[item.code] = item.appDisplay;
            });
        },
        handleSaveSearchTerms(data) {
            this.form.searchKeyWord = Array.isArray(data) ? data.join(',') : data;
        },

        handleChangeConfirmNoNeedSearchWords(value) {
            this.form.confirmNoNeedSearchWords = value?.[0] || false;
        },
        handleCommodityNameChange() {
            this.queryRecommendValue();
            this.setSimilarCSPUWithMarketingWord();
        },
        validateSKUName() {
            this.$refs.form.validateField('skuName');
        },
        handleCommodityNameFinish() {
            this.querySimilarCspuList();
            this.validateSKUName();
        },
        handleMarketingWordFinish() {
            this.validateSKUName();
        },
        async setSimilarCSPUWithMarketingWord() {
            const { commodityName } = this.form;
            this.similarNamesWithMarketingWord = await getSimilarCSPUNameWithMarketingWord(commodityName);
        },
        // 使用推荐值
        async handleUseRecommendValue(props = []) {
            props.forEach((item) => {
                this.form[item] = this.recommendValueObj[item];
            });
            // 使用推荐类目id时，调用接口（类目id的变化还可能来源于选择器的change，后期可将接口请求统一收敛到watch中调用）
            if (props.includes('bgCategoryId')) {
                await this.isFreshCategory();
                this.querySimilarCspuList();
            }
        },
        supplierChanged(val, node) {
            this.form.supplierName = (node && node.label) ? node.label : '';
            // this.form.categoryId = '';
            // this.form.categoryName = '';
            this.form.bgCategoryId = '';
            this.form.bgCategoryName = '';
        },
        async handleBgCategoryChange(val, node) {
            this.form.bgCategoryName = (node && node.name) ? node.name : '';

            // 如果后台分类是测试分类(0:非测试 1:测试")，在spu名称前,自动补充“测试”字符，
            const testSignReg = /^\(\u6d4b\u8bd5\)/;
            if (node.testSign === 1) {
                if (!testSignReg.test(this.form.spuName)) this.form.spuName = `(测试)${this.form.spuName}`;
                if (!testSignReg.test(this.form.commodityName)) this.form.commodityName = `(测试)${this.form.commodityName}`;
            }
            // 仅在用户操作时触发，更新后台/管理类目，重置spu名称
            if (!window._.isEmpty(node)) this.resetSpuInfo();

            this.queryRecommendValue();
            // 类目变化时，调用接口（类目id的变化还可能是使用推荐值直接赋值，后期可将接口请求统一收敛到watch中调用）
            await this.isFreshCategory();
            this.querySimilarCspuList();
            this.queryFocusAttr();
        },
        onCategoryChange(val, node) {
            this.form.categoryName = (node && node.name) ? node.name : '';
            if (!window._.isEmpty(node)) this.resetSpuInfo();
        },
        brandChooseChange(val) {
            this.form.brandName = (val && val.brandName) ? val.brandName : '';
            // 切换品牌，清空spu信息
            if (val && val.brandId) {
                this.resetSpuInfo();
            }
        },
        // 选中SPU之后回填管理类目、后台类目、品牌信息
        onSelectSpu(item) {
            this.selectSpu = item;
            this.form.spuBaseId = item.spuId;
            // this.form.categoryId = item.categoryId;
            // this.form.categoryName = item.category;
            // this.form.brandId = item.brandId;
            // this.form.brandName = item.brandName;
            // this.form.bgCategoryId = item.bgCategoryId;
            // this.form.bgCategoryName = item.bgCategory;
        },

        // 外部调用-获取表单数据
        getVMPostData() {
            // 特殊处理售卖城市，仅包括新增城市
            const { cityIds } = this.form;
            const filteredCityIds = cityIds.filter((x) => !!this.allSalesCity[x]);
            return {
                ...this.form,
                cityIds: filteredCityIds,
                taste: '',
            };
        },

        // 扩展属性相关
        onExtAttrSelected(extAttrList) {
            this.form.keyAttributes = extAttrList;
        },

        // 扩展属性加载完毕
        attrsLoaded(allAttrList) {
            // 保存到共享状态，后续都会用到全量属性列表
            updateSharedState('allExtAttrsList', allAttrList);
        },

        // 清空表单数据
        onClearSpuData() {
            this.form.spuName = '';
            this.form.spuBaseId = '';
        },

        // 点击修改重置SPU名称、管理类目、后台类目、品牌信息
        resetSpuInfo() {
            this.form.spuName = '';
            this.form.spuBaseId = '';
        },
        resetSkuInfo() {
            shared.currentSkuInfo = null;
            shared.existedCityIds = [];
            this.selectCurrentSku = {};
            this.form.cityIds = [];
            this.form.skuType = '';
        },
        resetSkuForm() {
            this.form.skuName = '';
            this.form.commodityName = '';
            this.form.marketingWord = '';
            this.form.spec = '';
            this.form.specActual = '';
            this.form.taste = '';
            this.form.searchKeyWord = '';
            this.form.confirmNoNeedSearchWords = false;
            // confirmNoNeedSearchWords在切换前后，值没有变化（watch不到的场景）：直接要求校验
            this.rules.searchKeyWord = [
                Rules.isRequired('请填写SKU搜索词'),
            ];
        },

        // 根据返回初始化管理类目下拉框
        onCategoryLoaded(data) {
            updateSharedState('categoryTreeData', data);
        },

        // 根据返回初始化后台类目下拉框
        onBgCategoryLoaded(data) {
            this.bgCategoryList = data;
            updateSharedState('bgCategoryTreeData', data);
            /**
             * 背景：
             * - 供货规则有值时，才会请求类目选择器数据，数据加载后将cspu信息中的类目id赋值给选择器
             * - 供货规则发生变化时，会清空之前赋值的类目id，这里重新赋值
             * 优先级：
             * - 已有（填写&算法推荐） > cspu信息
             */
            this.form.bgCategoryId = this.form.bgCategoryId || shared.similarCspuInfo?.bgCategoryId || '';
        },

        onDnaAttrsSelected(dnaAttrs) {
            this.form.dnaAttrs = dnaAttrs;
        },
        dnaAttrsLoaded(dnaAttrs) {
            this.showDnaAttrs = false;
            if (dnaAttrs && dnaAttrs.length) this.showDnaAttrs = true;
            // 保存到共享状态，后续都会用到全量属性列表
            updateSharedState('dnaAttrs', dnaAttrs);
        },

        // 根据后台类目获取sku和spu的命名规范和示例
        async getBgCategorySpec(bgCategoryId) {
            const { flowSpecByCategoryInfo } = await this.$service.queryBgCategoryConfig({ bgCategoryId });
            this.bgCategorySpec = flowSpecByCategoryInfo;
        },

        // TODO 本期暂时分开处理，2期把misid也通过后台类目查
        // 根据管理类目获取mis号是否必填
        // async getMisRequiredByCategory(categoryId) {
        //     const { flowSpecByMgCategoryInfo: { misIdRequired } } = await this.$service.getMisRequired({ mgCategoryId: categoryId });
        //     this.misIdRequired = misIdRequired; // 1是选填，2是必填
        // },

        // 1期暂时用这个
        // async getDefaultSkuTypeByBgCategory(bgCateId) {
        //     const { flowSpecByMgCategoryInfo: { skuTypeNormal } } = await this.$service.getMisRequired({ bgCategoryId: bgCateId });
        //     if (!this.form.skuType) { // 标品加工状态默认成品
        //         this.form.skuType = skuTypeNormal;
        //     }
        // },

        // TODO 2期用这个就可以
        // 根据后台类目查 mis号是否必填 ; 加工状态的默认值
        async getMisRequiredAndDefaultSkuTypeByBgCategory(mgCategoryId, bgCategoryId) {
            const { flowSpecByMgCategoryInfo: { skuTypeNormal } } = await this.$service.getMisRequired({ bgCategoryId, mgCategoryId });
            // this.misIdRequired = misIdRequired; // 1是选填，2是必填
            if (!this.form.skuType) { // 标品加工状态默认成品
                this.form.skuType = skuTypeNormal;
            }
        },

        // 清空检验状态
        clearValidate() {
            const formRefs = ['form'];
            formRefs.forEach((ref) => this.$refs[ref].clearValidate());
        },
        // 包含dna属性，扩展属性校验
        specialAttrValid() {
            // 防止notification提示重叠
            let result = true;
            if (this.$refs.dnaAttrs) {
                const dnaValid = this.$refs.dnaAttrs.validate();
                result = dnaValid;
            }
            if (result && this.$refs.extAttrs) {
                const extValid = this.$refs.extAttrs.validate();
                result = extValid;
            }
            return result;
        },
        // 对表单进行检验：外部调用
        async validate() {
            let validResult = false;
            const forms = ['form'];
            if (this.$refs.standardSpecForm) forms.push('standardSpecForm');
            try {
                const valids = await Promise.all(forms.map((ref) => {
                    let result = false;
                    this.$refs[ref].validate((valid) => { result = valid; });
                    return result;
                }));
                const specialValid = this.specialAttrValid();
                valids.push(specialValid);
                validResult = valids.every((valid) => valid === true);
            } catch (error) {
                this.handleDisabledValidatedFieldsError(forms);
                // pass
                // eslint-disable-next-line no-console
                console.warn('create::', error);
            }
            return validResult;
        },

        // 获取供货名称
        async getSupplierList() {
            const res = await this.$hGet('/api/vss/second/shepherd/supplier/query/supplier-list');
            this.supplierList = (res || []).map((item) => ({ value: item.supplierId, label: item.supplierName }));
            if (this.supplierList.length === 1) {
                this.form.supplierId = this.supplierList[0].value;
            }
        },

        // 根据供货名称和后台类目获取售卖城市
        async fetchCapableCity() {
            const { categoryId, supplierId, bgCategoryId } = this.form;
            if (!bgCategoryId || !supplierId) {
                this.allSalesCity = {};
                this.allAreaCityList = [];
                updateSharedState('allCityList', []);
                updateSharedState('allSalesCity', {});
                updateSharedState('allAreaCityList', []);
                return;
            }
            try {
                const response = await this.$service.queryCapableCityListWithRegion({
                    bgCategoryId,
                    mgCategoryId: categoryId,
                    supplierId,
                });
                const areaCityList = response?.list || [];
                this.allAreaCityList = areaCityList;
                // 将新API返回的数据转换为原来的对象结构
                const list = [];
                const citesMap = {};
                if (areaCityList.length === 0) {
                    this.allSalesCity = {};
                    this.allAreaCityList = [];
                    updateSharedState('allCityList', []);
                    updateSharedState('allSalesCity', {});
                    updateSharedState('allAreaCityList', []);
                    return;
                }
                (areaCityList[0].areaConfigList || []).forEach((area) => {
                    (area.manageCityList || []).forEach((city) => {
                        list.push(city);
                        citesMap[city.manageCityId] = {
                            label: city.manageCityName,
                            value: city.manageCityId,
                        };
                    });
                });
                this.allSalesCity = citesMap;
                updateSharedState('allCityList', list);
                updateSharedState('allSalesCity', citesMap);
                updateSharedState('allAreaCityList', areaCityList);
            } catch (error) {
                this.$message.error(error.msg || error.message || '获取供应商指定品类的可供城市列表失败');
            }
        },

        onChangeFixedAttrData({ attrName, attrValue, attrItem }) {
            switch (attrName) {
                case 'brandId':
                    this.form.brandId = attrValue;
                    this.form.brandName = (attrItem || { value: '' }).value;
                    if (attrValue !== '') {
                        this.resetSpuInfo();
                    }
                    break;
                case 'storageTemperatureLevel':
                    if (attrValue !== '') {
                        this.form.storageTemperatureLevelRemark = '';
                    }
                    break;
                default:
                    break;
            }
        },
        onExpandChange({ val, key }) {
            this.form[key] = val;
        },
        getDnaFixdAttrSelectedValue(attrName) {
            if (!this.form.dnaAttrs || !this.form.dnaAttrs.length) return [];
            const target = this.form.dnaAttrs.find((attr) => attr.attrAlias === attrName);
            if (!target) return [];
            return target.selectedValues;
        },

        onEditMisId() {
            this.$refs.editMisDialog._popup();
        },

        onMisIdUpdate({ misId, version }) {
            this.form.misId = misId;
            baseModel.models.version = version;
        },

        onPackageTypeChange(val) {
            // 散装时，清空消耗单位，数量
            if (val === 2) {
                // 散装 原料，规格自动填写kg；成品，规格填 500g
                if (!this.form.skuType || this.form.skuType === materialEnum) {
                    this.form.specActual = 'kg';
                } else {
                    this.form.specActual = '500g';
                }
            } else {
                // 切换标品时，清空规格
                this.form.specActual = '';
            }
            // 形态切换时，清空基础单位，因为基础单位options根据packageType来加载，可能出现value，options匹配不上的问题
            this.form.unitId = '';
            this.form.unitName = '';
            // 清空销售规格
            this.form.standardSpecList = [];
        },
        // 基础单位变化
        onUnitChange(id, item) {
            this.form.unitName = item.name;
        },
        onSkuTypeChange(val) {
            // 散装时，且加工状态=原料，规格自动改为500g；加工状态 = 成品/加工品 规格改为kg
            if (this.form.packageType === 2) {
                if (val === materialEnum) {
                    this.form.specActual = 'kg';
                    this.$alert('散装商品的加工状态为原料时，销售规格会自动调整为kg，代表称重商品');
                } else {
                    this.form.specActual = '500g';
                    this.$alert('散装商品的加工状态为成品或加工品时，主要为冬瓜切片类商品，为避免C端展示异常，销售规格会自动调整为500g', '提醒');
                }
            }
        },
        // 货品类型 = 特惠 赋值
        indulgenceAssignment() {
            if (this.mode) return;
            this.form.cityIds = Object.values(this.allSalesCity).map((item) => item.value); // 选中城市
            this.form.skuType = 1;
        },

        // 规格change
        changeSpecActual(val) {
            if (baseModel?.data?.applyInfoSection?.specActual !== val) {
            // 规格修改清空重量校验
                baseModel.models.ocrDescList.forEach((item) => {
                // type 101 为重量校验
                    if (item.type === 101) {
                        item.desc = '';
                    }
                });
            }
            this.form.specActual = val;
        },
    },
};
</script>

<style lang="scss" scoped>
.create-info {
    /deep/ .xx-categoryselect {
        width: 100%;
    }
    /deep/ .el-select, .el-cascader {
        width: 460px;
    }
    .search-key-word {
        min-width: 700px;
        .operation-area {
            display: flex;
            flex-wrap: row nowrap;
        }
    }
}
.recommend {
    width: 500px;
    display: flex;
    justify-content: space-between;
}
.textarea-w {
    width: 300px !important;
}
.mg-t-b-10 {
    margin: 10px 0;
}
.mg-b-20 {
    margin-bottom: 20px;
}
.max-width-750 {
    max-width: 750px;
}
.w-full {
    width: 100%;
}
.applyFor{
    color: #4f84f1;
    cursor: pointer;
}
.w-460 {
    width: 460px;
}
.ml-10 {
    margin-left: 10px;
}
</style>
